import React from 'react';
import {ProjectJson} from "../../api/json/ProjectJson"
import {AnyColumnJson} from "../../api/json/ColumnJson"
import {Tooltip} from "@mui/material"
import WarningAmberIcon from "@mui/icons-material/WarningAmber"

function ColumnIssueIcon({ project, column}: { project: ProjectJson, column: AnyColumnJson}) {
    let issues: string[] = []

    if (project.stats.totalRows > 0 && column.stats?.numberOfValues === 0)
        issues.push("Not used in any rows. Consider removing it.")

    if (issues.length === 0) {
        return <></>
    }

    return (
        <Tooltip title={issues.join(" ")}>
            <WarningAmberIcon color="warning" />
        </Tooltip>
    );
}

export default ColumnIssueIcon;